import styled, { css } from 'styled-components';
import { Text } from '~/components/ui/Text';
import { RewardType } from '~/shared';
import shadow from '../../assets/images/kit_open/item_shadow.png';

const StyledContainer = styled.div`
	position: relative;
	width: 290px;
	height: 240px;
	background: linear-gradient(
			0deg,
			rgba(255, 255, 255, 0.02),
			rgba(255, 255, 255, 0.02)
		),
		#111314;
	border: 1px solid rgba(255, 255, 255, 0.1);
	border-radius: 5px;
	overflow: hidden;
`;

const StyledShadow = styled.div`
	position: absolute;
	bottom: -250px;
	left: 50%;
	transform: translateX(-50%);
	width: 500px;
	height: 500px;
	background-image: url(${shadow});
	background-repeat: no-repeat;
	background-position: center;
	background-size: contain;
`;

const StyledText = styled(Text)`
	position: absolute;
	top: 27px;
	left: 50%;
	width: 100%;
	transform: translateX(-50%);
	font-size: 16px;
	font-weight: 500;
	color: #ffffff;
	max-width: 270px;
	text-align: center;
`;

const StyledImageContainer = styled.div<{ $type: RewardType }>`
	position: absolute;
	bottom: 40px;
	left: 50%;
	transform: translateX(-50%);

	${(props) =>
		(props.$type === RewardType.VEHICLE || props.$type === RewardType.ITEM) &&
		css`
			bottom: 40px;
		`}

	${(props) =>
		props.$type === RewardType.MONEY &&
		css`
			bottom: 30px;
		`}

		${(props) =>
		props.$type === RewardType.EXP &&
		css`
			bottom: 83px;
		`}	

		${(props) =>
		props.$type === RewardType.LOOTBOX &&
		css`
			bottom: -20px;
		`}

	img {
		user-select: none;
		pointer-events: none;
	}
`;

const StyledExpContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;

	${Text} {
		font-weight: 700;
		font-size: 30px;
		color: #ffffff;
	}
`;

const StyledImage = styled.img`
	width: auto;
	height: 120px;
	user-select: none;
	pointer-events: none;
`;

export {
	StyledContainer,
	StyledExpContainer,
	StyledImage,
	StyledImageContainer,
	StyledShadow,
	StyledText,
};
